
import useAxios from './Api';
import constants from "./Constants";

const useSystem = () => {

    const instance = useAxios();

    // Upload media
    const uploadMedia = async (user_id, base64String, callback) => {
        try {
          const file_name = 'Trovilo-' + user_id + '-' + Date.now();
          var contentTypeStart = base64String.indexOf(':') + 1; 
          var contentTypeEnd = base64String.indexOf(';base64');
          var content_type = base64String.substring(contentTypeStart, contentTypeEnd); 
          var base64 = base64String.split(',')[1];
          const blob = constants.base64ToBlob(base64, content_type);
          var formData = new FormData();
          formData.append('file', blob, file_name);
          formData.append('folder', 'uploads');
          formData.append('user_id', user_id);
          formData.append('file_type', content_type);
          var response = await fetch(constants.urls.media + '/upload-image', {
            method: "POST", body: formData
          });
          var results = await response.json();
          return callback(null, results)
        }
        catch (err) {
            var error = err?.response?.data || {};
            return callback({ 
                message: error?.message || 'Snap! Something went wrong',
                errors: error?.response?.data?.errors || []
            }, null)
        }
    }

    return {
        uploadMedia
    }
}

export default useSystem;